import {useLocation, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {EditLocalStoragePagesData} from "../../../../../utils/EditLocalStoragePagesData";
import MaterialPriceUnitService from "../../../../../API/orders/warehouse/MaterialPriceUnitService";
import MaterialReserveService from "../../../../../API/orders/reservation/MaterialReserveService";
import {Box} from "@mui/system";
import {BreadcrumbsComponent} from "../../../../../components/UI/breadcrumb/BreadcrumbComponent";
import {Typography} from "@mui/material";
import ArrivalMaterialModuleItem
    from "../../../../../components/UI/modul/arrivalmaterialmoduleitem/ArrivalMaterialModuleItem";
import ReservationMaterialEstimateUnitTable
    from "../../../../../components/UI/table/warehouse/reservation/ReservationMaterialEstimateUnitTable";
import ModalAlert from "../../../../../components/UI/table/customer-detales/ModalAlert";
import {constantsErrorMessages} from "../../../../../Constants";

export const ArrivalMaterialItemFromIssuance = () => {
    const {itemId, baseUnit, typeMaterial, orderId, nameOrder, materialEstimateUnitId, name, readOnly} = useParams();
    const pathname = useLocation().pathname

    const [data, setData] = useState([]);
    const [dataReserve, setDataReserve] = useState([]);
    const [unablePackaging, setUnablePackaging] = useState({});
    const [alertData, setAlertData] = useState({});
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(pathname, "pageSize", nextState.pageSize)
        }
    }
    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[pathname]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }

    useEffect(() => {
        getStartPageSize()
        MaterialPriceUnitService.getByIdWithPrices(itemId)
            .then(function (response) {
                setData(response.data);
                return response.data
            })
            .then((data) => {
                MaterialReserveService.getAllByMaterialWarehouseId(data?.materialWarehouse.id).then(function (response) {
                    const data = response.data;
                    data.forEach((row) => {
                        unablePackaging[row.id] = row.packaging;
                    });
                    setDataReserve(data);
                    setTableOptions((prev) => ({...prev, totalElements: response.data.length}))
                })
            })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);
    const handleUnableTurn = (id, status) => {
        unablePackaging[id] = status
        setUnablePackaging(prevState => ({
            ...prevState,
            [id]: status
        }));
    };
    const handleUnableCheckboxPackaging = (id, status) => {
        MaterialReserveService.setPackaging(id, status).then(function () {
            handleUnableTurn(id, status);
            handleModalAlert("Данные изменены", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    };
    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={`Приход`}
                path={[
                    {name: "Главная", href: "/"},
                    {name: "Выдача штучных материалов", href: "/organization/issuance-piece-materials"},
                    {
                        name: `Выдача штучных материалов заказа: ${nameOrder}`,
                        href: `/organization/issuance-piece-materials/${orderId}/${encodeURIComponent(nameOrder)}`
                    },
                    {
                        name: `Резервы`,
                        href: `/organization/issuance-piece-materials/${orderId}/${encodeURIComponent(nameOrder)}/${materialEstimateUnitId}/${typeMaterial}/${name}/${baseUnit}`
                    },
                ]}/>
            <Box sx={{display: "flex", flexDirection: "column"}}>
                <ArrivalMaterialModuleItem
                    isSlabMaterial={typeMaterial === 'SLAB'}
                    baseUnit={baseUnit}
                    readOnly={readOnly === "true"}
                    data={data}
                />
                <Box sx={{display: "flex", flexDirection: "column"}}>
                    <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                        {`Резервы`}
                    </Typography>
                </Box>
                <ReservationMaterialEstimateUnitTable
                    isArrival={true}
                    data={dataReserve}
                    setData={setDataReserve}
                    isButtonPurchase={false}
                    isSlab={false}
                    isColumnOrder={true}
                    isIssue={true}
                    unablePackaging={unablePackaging}
                    setUnablePackaging={handleUnableCheckboxPackaging}
                    handleModalAlert={handleModalAlert}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    isPackaging={true}
                    isPieceMaterials={true}
                    isReserveWareHouse={true}
                />
                <ModalAlert data={alertData} onClose={() => setAlertData((alert) => {
                    return {...alert, open: false}
                })}/>
            </Box>
        </Box>
    );
}